import MyListsCategoryFilter from 'components/RichProfile/MyLists/MyListsCategoryFilter/MyListsCategoryFilter';

export default MyListsCategoryFilter;
